<template>
  <fragment>
    <b-card :class="'main'">
        <h1>{{ $t("messages.not_found_title") }}</h1>
        <p>{{ $t("messages.not_found_body") }}</p>
    </b-card>

    <LoginForm v-if="!api_token" />
  </fragment>
</template>
<script>
import LoginForm from '../components/LoginForm.vue';

export default {
  components: {
    LoginForm
  },
  metaInfo() {
    return {
      title: this.$t("messages.not_found_title")
    }
  },
  data() {
    return {
      api_token: sessionStorage.getItem('api_token') || null
    }
  }
}
</script>